/**
 * @module components/NetworksMap
 * @author Charles Blais <charles.blais@canada.ca>
 * 
 * Station map display
 */

import React from 'react';
import PropTypes from 'prop-types';
import { CircleMarker, useMap } from 'react-leaflet';

import MyMapContainer from './MyMapContainer';
import { Station } from '../../libs/networks';


const ChangeView = ({ center, zoom }) => {
  const map = useMap();
  map.setView(center, zoom);
  return null;
}

/**
 * Network map with layers per network specified in input object
 * @param {*} props 
 */
const StationMap = ({station, zoom, radius, color}) => {
  const center = [station.latitude, station.longitude];
  return (
    <MyMapContainer
      center={center}
      zoom={zoom}
    >
      <ChangeView center={center} zoom={zoom} />
      <CircleMarker
        center={center}
        color={color}
        fillColor={color}
        radius={radius}
      />
    </MyMapContainer>
  );
};


StationMap.propTypes = {
  /**
   * Station object with required channels information
   */
  station: PropTypes.instanceOf(Station).isRequired,
  /**
   * Zoom level on the map
   */
  zoom: PropTypes.number,
  /**
   * Circle marker radius in pixels
   */
  radius: PropTypes.number,
  /**
   * HTML color of the circle marker
   */
  color: PropTypes.string,
};


StationMap.defaultProps = {
  zoom: 13,
  radius: 10,
  color: '#CD6155',
}


export default StationMap;